import React, { useState } from "react";
import Navbar from "../navbar/Navbar";
import "./AdminHOC.css";
import {  Layout} from "antd";
import { adminSidebarItems } from "../../../assets/constants/constants";

import SideBar from "../../global/Sidebar/SideBar";

const AdminHOC = (WrappedComponent) =>
  function AdminLayoutWrapper() {
    const [loading, setLoading] = useState(false);
    const [header, setHeader] = useState();
    const [breadcrumbs, setBreadCrumbs] = useState();
    const [hideSidebar, setHideSidebar] = useState(false);

    const { Header, Sider, Content } = Layout;
    return (
      <Layout
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        <Header
          style={{
            padding: 0,
            height: 0,
            background: "transparent",
            lineHeight: "normal",
            flexShrink: 0,
            zIndex: 999,
          }}
        >
          <Navbar />
        </Header>
        <div
          style={{
            marginTop:"80px",
            flexShrink: 0, 
            background:"#ffffff"
          }}
        >
          {breadcrumbs}
        </div>
        <Layout
          style={{
            flex: 1,
            minHeight: 0,
            padding: "24px",
            background: "#ffffff",
          }}
        >
          {!hideSidebar && (
          <Sider
            width={120}
            style={{
              background: "#ffffff",
              borderRadius: "10px",
              overflowY: "auto",
            }}
          >
            <SideBar items={adminSidebarItems} />
          </Sider>
          )}
          <Content style={{ padding:"0 0 24px 24px"}} className="bg-white rounded-[10px] w-full h-[80vh] overflow-y-scroll scrollbar-none [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            <WrappedComponent
              loading={loading}
              setLoading={setLoading}
              setHeader={setHeader}
              setBreadCrumbs={setBreadCrumbs}
              sidebarItems={adminSidebarItems}
              setHideSidebar={setHideSidebar}
            />
          </Content>
        </Layout>
      </Layout>
    );
  };
export default AdminHOC;
